<template>
    <div class="order-total">
        <div class="order-total__row">
            <p>{{ basketMessages.totalPrice }}</p>
            <p v-if="price">{{ price.printPriceOld }}</p>
        </div>

        <div class="order-total__row">
            <p>{{ basketMessages.discountPrice }}</p>
            <p v-if="price" class="def-sale">{{ price.printDiscount }}</p>
        </div>
        <div v-if="price.printDeliveryPrice" class="order-total__row">
            <p v-if="basketMessages.deliveryName">{{ basketMessages.deliveryName }}</p>
            <p v-if="price.printDeliveryPrice" class="def-free">{{ price.printDeliveryPrice }}</p>
        </div>
        <div class="order-total__row">
            <p>{{ basketMessages.price }}</p>
            <p v-if="price" class="def-price">{{ price.printPrice }}</p>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex';

export default {
    'name': 'OrderTotal',
    computed: {
        ...mapState({
            basketMessages: ({basket}) => basket.data.messages,
            price: ({basket}) => basket.data.price,
        }),
    },
}
</script>

<style lang="scss">
.order-total {
    &__row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 8px;
        font-size: rem(14);
        font-weight: 500;
        @include point-md {
            font-size: rem(16);
        }

        & > *:first-child {
            line-height: 100%;
            color: #757575;
        }
    }

    .def-sale {
        font-size: rem(14);
        @include point-md {
            font-size: rem(16);
        }
    }

    .def-free {
        font-size: inherit;
    }
}
</style>